export const SYSTEM_TAGS = [
  { value: 'high_risk_flood_zone', label: 'High-Risk Flood Zone', color: '#E05C6B' },
  { value: 'hoa',                  label: 'HOA',                  color: '#5B8DEF' },
  { value: 'occupied',             label: 'Occupied',             color: '#F5C542' },
  { value: 'vacant',               label: 'Vacant',               color: '#4CC9A0' },
];

export const TAG_COLORS = [
  // row 1
  '#DC2626', '#E05C6B', '#F97316', '#EAB308', '#15803D', '#84CC16', '#CA8A04',
  // row 2
  '#10B981', '#0F766E', '#7DD3FC', '#3B82F6', '#1D4ED8', '#4F46E5', '#9333EA',
  // row 3
  '#C026D3', '#DB2777', '#E5E7EB', '#9CA3AF', '#6B7280', '#374151', '#111827',
];
